<template>
  <div
    class="sli-cell"
    :class="[`sli-span-${span}`, { 'sli-cell--error': !!error, 'sli-cell--compact': compact, 'sli-cell--fit': fit !== null && fit !== '', 'sli-cell--date': type === 'date' }]"
    :style="fitStyle"
  >
    <label
      class="sli-cell__label"
      :for="inputId"
    >{{ label }}<span
      v-if="required"
      class="sli-req"
    >*</span></label>
    <textarea
      v-if="multiline"
      :id="inputId"
      :value="value"
      :rows="rows"
      :placeholder="placeholder"
      :disabled="disabled"
      autocomplete="off"
      class="sli-cell__input sli-cell__input--area"
      @input="$emit('input', $event.target.value)"
    />
    <input
      v-else
      :id="inputId"
      :value="value"
      :type="type"
      :placeholder="placeholder"
      :required="required"
      :disabled="disabled"
      :inputmode="inputmode"
      :maxlength="maxlength || undefined"
      :size="size || undefined"
      autocomplete="off"
      class="sli-cell__input"
      @input="$emit('input', $event.target.value)"
      @blur="$emit('blur')"
    >
    <span
      v-if="error"
      class="sli-cell__err"
    >{{ error }}</span>
  </div>
</template>

<script>
export default {
  name: 'SliField',
  props: {
    value: { type: [String, Number], default: '' },
    label: { type: String, required: true },
    inputId: { type: String, required: true },
    type: { type: String, default: 'text' },
    placeholder: { type: String, default: '' },
    required: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    inputmode: { type: String, default: 'text' },
    maxlength: { type: [String, Number], default: null },
    error: { type: String, default: '' },
    span: { type: [Number, String], default: 1 },
    multiline: { type: Boolean, default: false },
    rows: { type: [Number, String], default: 2 },
    compact: { type: Boolean, default: false },
    fit: { type: [Number, String], default: null },
    size: { type: [Number, String], default: null },
  },
  computed: {
    fitStyle() {
      if (this.fit === null || this.fit === '') return null
      return { '--sli-fit-ch': String(this.fit) }
    },
  },
}
</script>
